
export const data = [
    {
        "heading":"Panda Talks",
        "stack":"Flutter, Gin, WebSocket, Firebase",
        "url":"https://res.cloudinary.com/dqhsop4rx/image/upload/v1735591680/pandatalksss_jwkl0n.png",
        "link":"https://drive.google.com/drive/u/0/folders/1RFT72lPamb0U2QpSPlzvKrCHKu99uH5e",
        "github":"https://github.com/adit9852/Flutter_PandaTalks",
        "desc": ["PandaTalks Flutter App: Experience seamless chatting with friends without signup! Create and share room passwords for instant connections, ensuring privacy with encrypted messages. Built with Flutter, PandaTalks delivers a user-friendly interface, fostering secure and spontaneous conversations with your pals. Chat without boundaries! "]
    },
    {
        "heading":"Cpi Guru",
        "stack":"ReactJS,javaScript,Css,Redis",
        "url":"https://res.cloudinary.com/dqhsop4rx/image/upload/v1735592395/cpigurusss_xfthio.png",
        "link":"https://cpi-guru-beta.vercel.app/",
        "github":"https://github.com/adit9852/CpiGuru",
        "desc": ["Created a React app is designed to assist RGIPT students in calculating Cumulative Performance Index (CPI) and Semester Performance Index (SPI). Additionally, and you can share your academic achievements with friends."]
    },
    {
        "heading":"E-Vehicle Site",
        "stack":" HTML, CSS, Javascript, ReactJS, nodeJS ,Firebase",
        "url":"https://res.cloudinary.com/dqhsop4rx/image/upload/v1735592397/evehiclesss_efjooe.png",
        "link":"https://e-vehicle-website.vercel.app/",
        "github":"https://e-vehicle-website.vercel.app/",
        "desc": ["Developed a The E-Vehicle site, this website is more than just a digital storefront; it's a dynamic hub designed to revolutionize the e-vehicle industry. Serving as an all-in-one solution, it seamlessly integrates features for product showcasing, bike sales, and accessory procurement."]
    },
    {
        "heading":"Advance Virtual TryOn",
        "stack":"HR-Viton ,PoseNet , Graphony ,Detectron 2 , PyTorch ",
        "url":"https://res.cloudinary.com/dqhsop4rx/image/upload/v1735593231/advsss_gpxfce.png",
        "link":"https://github.com/adit9852/Advance-Virtual-TryON",
        "github":"https://github.com/adit9852/Advance-Virtual-TryON",
        "desc": ["This project provides an efficient pipeline for garment segmentation, pose estimation, and garment overlay to enable realistic virtual try-on experiences."]

    },
    {
        "heading":"StudyNotion",
        "stack":"HTML, CSS, Javascript, ReactJS, NodeJS, MongoDB, ExpressJS",
        "url":"https://res.cloudinary.com/dqdy8u03v/image/upload/v1702746104/studynotion_yqw9a9.png",
        "link":"https://studynotion-by-adityarana.vercel.app/",
        "github":"https://studynotion-by-adityarana.vercel.app/",
        "desc": ["Developed an edtech website where students can access and learn from a wide range of courses, providing an engaging and effective educational experience.", "Implemented Redux to efficiently manage application states, ensuring seamless data flow and user interaction.", "Created a visually appealing and responsive user interface using Tailwind CSS, enhancing the overall user experience."]
    },
    {
        "heading":"Spring Messenger",
        "stack":"Java , Spirng-Boot , Eclipse J2EE",
        "url":"https://res.cloudinary.com/dqhsop4rx/image/upload/v1735593829/springsss_qqejjk.png",
        "link":"https://sending-e-mail-using-spring-boot-mail.vercel.app/",
        "github":"https://github.com/adit9852/Sending-E-mail-using-Spring-Boot-Mail",
        "desc": ["In this project, I have implemented an email-sending functionality using the Spring Boot Mail API, allowing seamless communication by sending emails to other accounts."]
    },
]